import React from 'react';
import HorizontalRule from '../../../components/common/HorizontalRule';
import {OverviewBenefitsItem} from '../../../reducers/overview';

//@ts-ignore
import styles from './BenefitItem.pcss';

export type BenefitItemProps = OverviewBenefitsItem;

const BenefitItem: React.FC<BenefitItemProps> = props => (
    <div className={styles.benefitItem}>
        <div>
            <h3>{props.title}</h3>
            <HorizontalRule />
            <div dangerouslySetInnerHTML={{__html: props.body}} />
        </div>
    </div>
);

export default BenefitItem;
